import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getItems = createAsyncThunk(
  "menu_items",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/menu_items/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);


export const getAllItems = createAsyncThunk(
  "all_menu_items",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/menu_items/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getItem = createAsyncThunk(
  "getmenuitem",
  async (id, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/menu_items/${id}/`,
        // { params },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteItem = createAsyncThunk(
  "deletemenuitem",
  async (id, { rejectWithValue }) => {
    try {
      const data = await axiosClient.delete(
        `${config.API_URL}/menu_items/${id}/`,
        {}, // { params },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getMenu = createAsyncThunk(
  "menus",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/menus/`,
        {},
        config
      );

      return data;
    } catch (error) {
      // return custom error message from API if any-
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);


export const getMenuById = createAsyncThunk(
  "menus",
  async (id, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/menus/${id}/`,
        {},
        config
      );

      return data;
    } catch (error) {
      // return custom error message from API if any-
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const resetSubMenus = createAsyncThunk(
  "resetSubMenus",
  async (params, { rejectWithValue }) => {
    return;
  }
);

export const getSubMenus = createAsyncThunk(
  "submenus",
  async (id, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/menus/${id}/sub_menus/`,
        {},
        config
      );
      return data;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const addSubMenu = createAsyncThunk(
  "addsubmenu",
  async ({ activeKey, name, id, sync_with_metrc, is_connected,sale }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/menus/${activeKey}/sub_menus/`,
        { name, external_id: id, sync_with_metrc, is_connected,sale},
        config
      );
      return data;
    } catch (error) {
      if (error.response && Object.keys(error.response.data).length > 0) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getMultivendorVendors = createAsyncThunk(
  "getmultivendorvendors",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/menus/multivendor-vendors/`,
        {},
        config
      );
      return data;
    } catch (error) {
      if (error.response && Object.keys(error.response.data).length > 0) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getBlazeVendors = createAsyncThunk(
  "getblazevendors",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(`${config.API_URL}/blaze/vendors/`, {}, config);
      return data;
    } catch (error) {
      if (error.response && Object.keys(error.response.data).length > 0) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const triggerBlazeSync = createAsyncThunk(
  "triggerblazesync",
  async ({ menu }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/blaze/sync/`,
        { menu },
        config
      );
      return data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue({
          status: error.response.status,
          ...(error.response.data || {}),
        });
      }
      return rejectWithValue({ detail: error.message });
    }
  }
);

export const getBlazeSyncStatus = createAsyncThunk(
  "getblazesyncstatus",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(`${config.API_URL}/blaze/sync/`, {}, config);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const editSubMenu = createAsyncThunk(
  "editsubmenu",
  async (
    {
      menuId,
      id,
      text,
      external_id,
      sync_with_metrc,
      is_connected,
      sale,
      blaze_inventory_id,
      weedvader_menu_id,
    },
    { rejectWithValue }
  ) => {
    try {
      const payload = {
        name: text,
        sync_with_metrc,
        external_id,
        is_connected,
        sale,
      };
      if (blaze_inventory_id !== undefined) {
        payload.blaze_inventory_id = blaze_inventory_id || null;
      }
      if (weedvader_menu_id !== undefined) {
        payload.weedvader_menu_id = weedvader_menu_id || null;
      }
      const data = await axiosClient.patch(
        `${config.API_URL}/menus/${menuId}/sub_menus/${id}`,
        payload,
        config
      );
      return data;
    } catch (error) {
      if (error.response && Object.keys(error.response.data).length > 0) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const removeSubMenu = createAsyncThunk(
  "removesubmenu",
  async ({ menuId, id, confirm }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.delete(
        `${config.API_URL}/menus/${menuId}/sub_menus/${id}${
          confirm ? `?confirm=${encodeURIComponent(confirm)}` : ""
        }`,
        {},
        config
      );
      return id;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const addMenu = createAsyncThunk(
  "addmenu",
  async ({ name }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/menus`,
        { name },
        config
      );

      return data;
    } catch (error) {
      if (error.response && Object.keys(error.response.data).length > 0) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const removeMenu = createAsyncThunk(
  "removemenu",
  async (payload, { rejectWithValue }) => {
    // Accepts a bare id (legacy callers) or { id, confirm }. The API refuses to
    // drop a menu that still holds items or feeds an integration unless the
    // name is confirmed back to it.
    const id = typeof payload === "object" && payload !== null ? payload.id : payload;
    const confirm =
      typeof payload === "object" && payload !== null ? payload.confirm : undefined;
    try {
      const data = await axiosClient.delete(
        `${config.API_URL}/menus/${id}${
          confirm ? `?confirm=${encodeURIComponent(confirm)}` : ""
        }`,
        {},
        config
      );
      return id;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateMenu = createAsyncThunk(
  "updateMenu",
  async ({ id, updated_name }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/menus/${id}`,
        { name: updated_name },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && Object.keys(error.response.data).length > 0) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const postImage = createAsyncThunk(
  "postImage",
  async (formData, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/images/`,
        formData,
        config
      );

      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const requestVideoUploadUrl = createAsyncThunk(
  "videoUploadUrl",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(`${config.API_URL}/videos/upload-url/`, {}, config);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const finalizeVideo = createAsyncThunk(
  "videoFinalize",
  async ({ uid, target_type, target_id, duration_sec }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/videos/finalize/`,
        { uid, target_type, target_id, duration_sec },
        config
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteVideo = createAsyncThunk(
  "videoDelete",
  async (uid, { rejectWithValue }) => {
    try {
      const data = await axiosClient.delete(`${config.API_URL}/videos/${uid}/`, config);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const getVariants = createAsyncThunk(
  "variants",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/variants/`,
        {},
        config
      );
      return data;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createMenuItem = createAsyncThunk(
  "create-custom-menuitem",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/menu_items/`,
        params,
        config
      );

      return data;
    } catch (error) {
      // return custom error message from API if any
      //   if (error.response && error.response.data.message) {
      //     return rejectWithValue(error.response.data.message);
      //   } else {
      //     return rejectWithValue(error.message);
      //   }
      return rejectWithValue(error.response.data);
    }
  }
);



export const updateBarcodeMenuItem = createAsyncThunk(
  "update-barcodemenuitem",
  async (params, { rejectWithValue }) => {
    const { id, ...serverData } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/menu_items/barcode/${id}`,
        serverData,
        config
      );

      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateMenuItem = createAsyncThunk(
  "update-menuitem",
  async (params, { rejectWithValue }) => {
    const { id, ...serverData } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/menu_items/${id}`,
        serverData,
        config
      );

      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_possible_sub_menus = createAsyncThunk(
  "get_possible_sub_menus",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/sub_menus/`,
        { params },
        config
      );

      return data;
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const sync_menu_items = createAsyncThunk(
  "sync_menu_item",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/menu_items/sync/`,
        params,
        config
      );

      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);


export const transfer_menu_items = createAsyncThunk(
  "transfer_menu_items",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/menu_items/transfer/`,
        params,
        config
      );

      return data;
    } catch (error) {
      const data = error.response?.data;
      if (data && typeof data === "object") {
        return rejectWithValue({ ...data, _status: error.response?.status });
      }
      return rejectWithValue({ Error: error.message });
    }
  }
);


export const merge_menu_items = createAsyncThunk(
  "merge_menu_items",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/menu_items/merge/`,
        params,
        config
      );

      return data;
    } catch (error) {
      const data = error.response?.data;
      if (data && typeof data === "object") {
        return rejectWithValue({ ...data, _status: error.response?.status });
      }
      return rejectWithValue({ Error: error.message });
    }
  }
);


export const getMenuItemTransfers = createAsyncThunk(
  "menu_item_transfers",
  async (
    { id, direction = "outgoing", page = 1, per_page = 10, sub_menu_ids = [] },
    { rejectWithValue }
  ) => {
    try {
      const params = { direction, page, per_page };
      if (Array.isArray(sub_menu_ids) && sub_menu_ids.length) {
        params["sub_menu_ids[]"] = sub_menu_ids;
      }
      const data = await axiosClient.get(
        `${config.API_URL}/menu_items/${id}/transfers/`,
        { params },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ Error: error.message });
    }
  }
);

export const getBarcodeItem = createAsyncThunk(
  "get_barcode_item",
  async (id, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/menu_items/barcode/${id}`,
        // { params },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from API if any
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

// [WV-FEATURED-SLOTS] Weedvader owns the featured position; Canasale keeps no
// copy. Read the six slot holders live right before the picker opens, and send
// the position only when the operator picks one.
export const getWeedvaderFeaturedSlots = createAsyncThunk(
  "menu/getWeedvaderFeaturedSlots",
  async (id, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/menu_items/${id}/weedvader_featured/`,
        config
      );
      return data;
    } catch (error) {
      if (error.response && Object.keys(error.response.data).length > 0) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const setWeedvaderFeaturedSlot = createAsyncThunk(
  "menu/setWeedvaderFeaturedSlot",
  async ({ id, position }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.put(
        `${config.API_URL}/menu_items/${id}/weedvader_featured/`,
        { position },
        config
      );
      return data;
    } catch (error) {
      if (error.response && Object.keys(error.response.data).length > 0) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

// Same board, read by submenu — for the create form, where no item exists yet.
export const getWeedvaderFeaturedSlotsForSubmenu = createAsyncThunk(
  "menu/getWeedvaderFeaturedSlotsForSubmenu",
  async (subMenuId, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/sub_menus/${subMenuId}/weedvader_featured/`,
        config
      );
      return data;
    } catch (error) {
      if (error.response && Object.keys(error.response.data).length > 0) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

// "Sync to Weedmaps / Weedvader": re-send every item of a submenu to one
// vendor. POST starts it (202, or 429 with cooldown_remaining), GET polls it.
export const triggerVendorSync = createAsyncThunk(
  "menu/triggerVendorSync",
  async ({ subMenuId, vendor }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/sub_menus/${subMenuId}/vendor_sync/`,
        { vendor },
        config
      );
      return data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue({
          status: error.response.status,
          ...(error.response.data || {}),
        });
      }
      return rejectWithValue({ detail: error.message });
    }
  }
);

export const getVendorSyncStatus = createAsyncThunk(
  "menu/getVendorSyncStatus",
  async ({ subMenuId, vendor }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/sub_menus/${subMenuId}/vendor_sync/?vendor=${vendor}`,
        config
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
